import { Controller } from 'stimulus'
import { gsap } from "gsap/all"

export default class extends Controller {
  static targets = ['dialog', 'lightbox']

  connect() {
    this.hideLightBox()
  }

  toggle(event) {
    this.dialog(event.currentTarget.dataset.key).toggle(new Event('click'))
  }

  open(event) {
    this.dialog(event.currentTarget.dataset.key).open(new Event('click'))
  }

  close(event) {
    this.dialog(event.currentTarget.dataset.key).close(new Event('click'))
  }

  minimizeIfClosed(event) {
    this.dialog(event.currentTarget.dataset.key).minimizeIfClosed(new Event('click'))
  }

  minimize(key) {
    this.dialog(key).minimize(new Event('click'))
  }

  closeByKey(key) {
    this.dialog(key).close(new Event('click'))
  }

  showLightBox() {
    gsap.to(this.lightboxTarget, 0.3, {autoAlpha: 1, display:'block'})
  }

  hideLightBox() {
    gsap.to(this.lightboxTarget, 0.3, {autoAlpha: 0, display:'none'})
  }

  dialog(key) {
    for(let controller of this.application.controllers) {
      if ('dialog' == controller.identifier && controller.element.dataset.key == key) {
        return controller
      }
    }
  }
}
